// src/components/layout/AdminSidebar.jsx
import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

const navigation = [
    // { name: 'Dashboard', href: '/admin' },
    { name: 'Content Management', href: '/admin/cms' },

    {
        name: 'Submissions',
        href: '#',
        children: [
            { name: 'Contact Forms', href: '/admin/submissions/contact' },
            { name: 'Enquiries', href: '/admin/submissions/enquiry' },
            { name: 'Newsletter', href: '/admin/submissions/newsletter' },
            { name: 'Career Applications', href: '/admin/submissions/career' },
        ]
    },
    {
        name: 'Content',
        href: '#',
        children: [
            { name: 'Blog Posts', href: '/admin/blogs' },
            { name: 'Testimonials', href: '/admin/testimonials' },
            { name: 'Webinars', href: '/admin/webinars' },
            { name: 'Case Studies', href: '/admin/case-studies' },
            { name: 'Jobs', href: '/admin/jobs' },
            { name: 'Services', href: '/admin/services' },
            { name: 'Industries', href: '/admin/industries' }
        ]
    },
    {
        name: 'Settings',
        href: '#',
        children: [
            { name: 'Email Config', href: '/admin/settings/email' },
        ]
    },
]

export default function AdminSidebar() {
    const location = useLocation()
    const [expandedItems, setExpandedItems] = useState(() => {
        // Default expanded items based on current path
        const defaultExpanded = []
        navigation.forEach(item => {
            if (item.children) {
                const isActiveChild = item.children.some(child =>
                    location.pathname.startsWith(child.href)
                )
                if (isActiveChild) {
                    defaultExpanded.push(item.name)
                }
            }
        })
        return defaultExpanded
    })

    const toggleItem = (itemName) => {
        setExpandedItems(prev =>
            prev.includes(itemName)
                ? prev.filter(name => name !== itemName)
                : [...prev, itemName]
        )
    }

    const isItemActive = (item) => {
        if (item.children) {
            return item.children.some(child => location.pathname === child.href)
        }
        return location.pathname === item.href
    }

    // Check if a parent item should be expanded
    const shouldParentBeActive = (item) => {
        if (item.children) {
            return item.children.some(child => location.pathname.startsWith(child.href.split('/')[2]))
        }
        return false
    }

    return (
        <div className="sidebar-content h-full">
            <div className="p-6">
                <div className="flex items-center space-x-2">
                    <span className="text-xl font-bold">LogiQlink</span>
                </div>
                <p className="text-gray-400 text-sm mt-2">Admin Panel</p>
            </div>

            <nav className="mt-6 px-3">
                <div className="space-y-2">
                    {navigation.map((item) => (
                        <div key={item.name} className="nav-item">
                            {item.children ? (
                                <>
                                    <button
                                        onClick={() => toggleItem(item.name)}
                                        className={`group flex items-center justify-between w-full px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${isItemActive(item) || shouldParentBeActive(item)
                                            ? 'bg-primary-600 text-white'
                                            : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                                            }`}
                                    >
                                        <div className="flex items-center">
                                            <span className="font-medium">{item.name}</span>
                                        </div>
                                        <span className={`transform transition-transform duration-200 ${expandedItems.includes(item.name) ? 'rotate-90' : ''}`}>
                                            ›
                                        </span>
                                    </button>

                                    {expandedItems.includes(item.name) && (
                                        <div className="ml-9 mt-1 space-y-1">
                                            {item.children.map((child) => (
                                                <NavLink
                                                    key={child.name}
                                                    to={child.href}
                                                    className={({ isActive }) =>
                                                        `group flex items-center px-3 py-2 text-sm rounded-lg transition-colors ${isActive
                                                            ? 'bg-primary-600/20 text-primary-300 border-l-2 border-primary-500'
                                                            : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                                                        }`
                                                    }
                                                >
                                                    <span>{child.name}</span>
                                                </NavLink>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <NavLink
                                    to={item.href}
                                    className={({ isActive }) =>
                                        `group flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${isActive
                                            ? 'bg-primary-600 text-white'
                                            : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                                        }`
                                    }
                                >
                                    <span className="font-medium">{item.name}</span>
                                </NavLink>
                            )}
                        </div>
                    ))}
                </div>
            </nav>
        </div>
    )
}